import { ApolloError } from '@apollo/client';
import { CrewMember, SaveTimesheetChargesError, SaveTimesheetError } from '@bechtel/types';

export type SaveTimeSheetErrorType = SaveTimesheetError | ApolloError;

export interface SaveTimeSheetErrorProps {
  errors: SaveTimesheetChargesError[] | ApolloError;
  crewMemberList?: CrewMember[];
  close: () => void;
}
